// Copy for the Civitas landing page. Edit this, not the markup.
//
// Everything here is a fact about the shipped game. Don't add claims the app
// can't back up (other platforms, multiplayer, pricing, reviews).

export const APP_STORE_URL = 'https://apps.apple.com/ca/app/civitas-early-access/id6502847538';
export const X_URL = 'https://x.com/civitasgame_';
export const PRIVACY_PATH = '/civitas-privacy';
export const VERSION = '0.9.0';

export const HERO = {
  title: 'Civitas',
  // Other taglines considered:
  //   'Found a city. Raise an empire. Your turn.'
  //   'Nine civilizations. One world. Your move.'
  //   'A whole civilization game, held in one hand.'
  tagline: 'From one city to an industrial empire, one turn at a time.',
  summary: 'A turn-based civilization strategy game for iPhone and iPad.',
  cta: 'Download on the App Store',
  note: `Early Access · Version ${VERSION}`,
};

export const FEATURES = {
  heading: 'The game',
  cards: [
    {
      title: 'Build',
      body: 'Found cities and put the land around them to work with farms, mines, lumber and quarries.',
    },
    {
      title: 'Research',
      body: 'Work through the tech tree and advance era by era, from the ancient world to an industrial age of infantry, artillery, ironclads and railroads.',
    },
    {
      title: 'Explore',
      body: 'Send land and naval units out across the map. There are ancient ruins to explore, and barbarians who would rather you didn’t.',
    },
    {
      title: 'Negotiate',
      body: 'Every rival is an AI civilization with a leader of its own. Diplomacy decides who you are at war with and who you make peace with.',
    },
    {
      title: 'Choose your world',
      body: 'Lakes, Pangea, Continents, Archipelago, or a hand-built Earth map with optional historical start locations. Sizes run from Small to Giga, with up to seven opponents.',
    },
    {
      title: 'Start anywhere',
      body: 'A built-in tutorial walks you through your first game, and three difficulty levels keep the single-player challenge where you want it.',
    },
  ],
};

// Laid out like the game's civ picker (components/PickCiv.js in the game
// repo): leader, tint and buff come from data/players.json and
// utility/civBuffs.js there. `key` picks the portrait (civitas-leader-<key>).
export const CIVILIZATIONS = {
  heading: 'Nine civilizations',
  intro: 'Each one has its own leader, a unique bonus and a unique unit.',
  list: [
    { key: 'rome', name: 'Rome', leader: 'Julius Caesar', tint: '#7200b035',
      buff: { name: 'Glory of Rome', description: '+15% combat strength when attacking.' } },
    { key: 'persia', name: 'Persia', leader: 'Cyrus the Great', tint: '#f2ee0035',
      buff: { name: 'The Immortals', description: 'Units heal twice as fast.' } },
    { key: 'spain', name: 'Spain', leader: 'Charles V', tint: '#523A2835',
      buff: { name: 'New World Gold', description: 'Every city earns +1 extra gold per turn.' } },
    { key: 'england', name: 'England', leader: 'Elizabeth I', tint: '#d4150035',
      buff: { name: 'Sceptered Isle', description: 'Cities defend with +25% combat strength.' } },
    { key: 'france', name: 'France', leader: 'Louis XIV', tint: '#020dd435',
      buff: { name: 'Sun King’s Splendor', description: 'Tile improvements produce +1 extra gold.' } },
    { key: 'germany', name: 'Germany', leader: 'Otto von Bismarck', tint: '#87878750',
      buff: { name: 'Prussian Efficiency', description: 'Technologies cost 20% less.' } },
    { key: 'russia', name: 'Russia', leader: 'Peter I', tint: '#007a1035',
      buff: { name: 'The Endless Steppe', description: 'All units have +1 movement.' } },
    { key: 'america', name: 'America', leader: 'George Washington', tint: '#adb1ff50',
      buff: { name: 'Arsenal of Democracy', description: 'Units cost 25% less gold to buy or upgrade.' } },
    { key: 'japan', name: 'Japan', leader: 'Emperor Meiji', tint: '#ff9f9c35',
      buff: { name: 'Bushido', description: 'Units fight at full strength even when damaged.' } },
  ],
};

// SCREENSHOT SLOTS: the project has no Civitas screenshots or game art yet
// (only the logo and the QR code). Add captures here and the page shows them
// in frosted frames between the hero and the features; while this is empty the
// section isn't rendered at all.
//   { src: importedImage, alt: 'What the screen shows', width: 1290, height: 2796 }
export const SCREENSHOTS = [];

export const FOOTER = {
  status: `Civitas is in Early Access (version ${VERSION}) and under active development.`,
  credits: 'Created by Michael Taciuk. Music by Nick Brown.',
  links: {
    appStore: 'App Store',
    x: 'X',
    privacy: 'Privacy',
  },
};
